/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {
  MasterCardIcon,
  InfoWhiteIcon,
} from '../../assets/svg/MasterCardIcons';
import Spinner from '../Spinner';
import { useProductName, UserDataType } from '@rb-serve-app/core';
import { useSelector } from 'react-redux';

type Props = {
  assets: any;
  contentfulData: any;
};
const VerticalCard = ({ assets, contentfulData }: Props) => {
  const { rewards: rewardsData } = useSelector((state: any) => state.rewards);

  const { accountDetails } = useSelector((state: any) => state?.user);
  const { productName, cardStructure } = useProductName();
  return (
    <div
      data-testid="verticle-card"
      className="p-4 rounded-lg text-white lg:my-0  w-[117px] h-[186px] max-h-[186px] max-w-[117px] lg:w-[220px] lg:max-w-[220px] lg:max-h-[230px] lg:h-[230px]
      ipad-portrait:w-[145px] ipad-portrait:h-[230px] ipad-portrait:max-w-[145px] ipad-portrait:max-h-[230px]
     
     flex flex-col self-center justify-start items-center relative"
      role="group"
      aria-labelledby="card-info"
      style={{
        backgroundImage: `url("${cardStructure?.imgUrl || 'default-image.png'}")`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }}
    >
      <span id="card-info" className="sr-only">
        Card Details
      </span>
    </div>
  );
};

export default VerticalCard;
